const showingMessagesItems = [
  "All messages",
  "Messages with tags",
  "Messages with attachments",
  "Messages with images",
  "Messages with gifs",
  "Messages with links",
];

export default showingMessagesItems;